import React, { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

const departments = [
    { "name": "विज्ञप्ति", "link": "#" },
    { "name": "निविदा", "link": "#" },
];

export default function NoticesAndTenders() {
    const [showSidebar, setShowSidebar] = useState(true);
    const [content, setContent] = useState("कृपया किसी अनुभाग का चयन करें।");

    const handleItemClick = (deptName) => {
        setContent(deptName);
        setShowSidebar(false); // Sidebar को बंद करना
    };

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">
            {/* Toggle Button for Small Screens */}
            <button
                className="btn btn-primary d-md-none m-2"
                onClick={() => setShowSidebar(!showSidebar)}
            >
                ☰ मेनू
            </button>

            {/* Sidebar */}
            <aside className={`text-white p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none d-md-flex"} col-md-3`}>
                <h5 className="text-center fw-bold mb-3 text-dark">विज्ञप्ति एवं निविदा</h5>
                <div className="flex-grow-1 overflow-auto">
                    {departments.map((dept, index) => (
                        <p
                            key={index}
                            className="mb-1 p-2 bg-white text-dark rounded shadow-sm small cursor-pointer"
                            onClick={() => handleItemClick(dept.name)}
                            style={{ cursor: "pointer" }}
                        >
                            {dept.name}
                        </p>
                    ))}
                </div>
            </aside>

            {/* Main Content */}
            <main className="flex-grow-1 p-3 bg-white shadow col-md-9" onClick={() => setShowSidebar(false)}>
                <h5></h5>
                <p>{content}</p>
            </main>
        </div>
    );
}